(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grid_with_slider"] && !Shopify.designMode) return;
  try {
    
    
    var swiper = new Swiper(".custom_swiper", {
        slidesPerView: 1, 
        spaceBetween: 15,
        freeMode: false,
      loop: true,
        simulateTouch:true, 
     autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },

        pagination: {
            el: ".custom_pegination",
            clickable: true,
        },
        breakpoints: {
            // 0: {
            // slidesPerView: 2,
            // spaceBetween: 20,
            // },
            768: {
            slidesPerView: 2,
            spaceBetween: 30,
            freeMode: false,
            simulateTouch:false, 
              loop: false,
            },
            1200: {
            slidesPerView: 2,
            spaceBetween: 0,
            freeMode: false,
            simulateTouch:false, 
              loop: false,
               autoplay: false,
             
            },
        },
        });
        window.addEventListener('resize', function() { 
            swiper.slideTo(0); // Moves the slider to slide number 1 (index 0)
          slider.autoplay.start(); 
          
        });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news_slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".news_slider", {
  spaceBetween: 5,
  slidesPerView: 2,
  loop: true,
  speed: 2500,
  autoplay: {
    delay: 1,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: ".news_slider_next",
    prevEl: ".news_slider_prev",
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});

    var slides = document.querySelectorAll(".news_slider"); 
    slides.forEach(function (slide) {
      slide.addEventListener("mouseenter", function () {
        swiper.autoplay.stop();
      });

      slide.addEventListener("mouseleave", function () {
        swiper.autoplay.start();
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
     var swiper = new Swiper(".banner_swiper", {
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop:true, 
                    autoplay: { 
                    disableOnInteraction: false,
                    },
                    pagination: {
                    el: ".banner_pegination", 
                    clickable: true,
                    },
                    navigation: {
                    nextEl: ".banner_next_btn",
                    prevEl: ".banner_prev_btn",
                    },
                });

  } catch(e) { console.error(e); }
})();
})();
